import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useTokenCheck from '../../useTokenCheck';
import Loading from '../common/Loader/loader';

const ProtectedRoute = ({ children }) => {
    const { isAuthenticated } = useSelector((state) => state.auth);
    const [loading, setLoading] = useState(true);

    useTokenCheck();

    useEffect(() => {
        if (isAuthenticated !== undefined || isAuthenticated || isAuthenticated !== null) setLoading(false);
    }, [isAuthenticated]);

    if (loading) return <Loading />;

    return isAuthenticated ? children : <Navigate to="/" />;
};

export default ProtectedRoute;